import React, { useEffect, useContext } from 'react';
import { Row, Col } from 'antd';

import { webServiceProvider } from 'shared';
import ShopStore from 'stores/ShopStore';
import WorkOrderDetailsContext from '../../../containers/WorkOrder/WorkOrderDetailsContext';

import PM from './PM';

function PMsContainer({
  itemKey,
  pms,
  addSubItem,
  deleteSubItem,
  changeSubItem,
  changeItemProperty,
}) {
  const shopId = ShopStore.currentShop.id;
  const [PMs, setPMs] = React.useState([]);

  const contextValue = useContext(WorkOrderDetailsContext);

  const {
    state: { carDetails },
  } = contextValue;

  const carId = carDetails?.id;

  const fetchPMs = async (carId) => {
    try {
      const fetchPMsController = new AbortController();
      const fetchPMsSignal = fetchPMsController.signal;
      const params = {
        offset: 0,
        limit: 10,
        status: 'new',
        source: 'routine',
        safetyInspection: false,
        shopId,
      };
      const result = await webServiceProvider.getMany(
        `v1/cars/${carId}/pms`,
        params,
        fetchPMsSignal
      );

      setPMs(result?.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!carId) {
      return;
    }
    fetchPMs(carId);
  }, [carId]);

  return (
    <Row style={{ margin: '10px' }} gutter={16}>
      <Col span={24}>
        <PM
          allPMs={pms}
          PMs={PMs}
          itemKey={itemKey}
          deleteSubItem={() => deleteSubItem(itemKey, 'pms')}
          changeItemProperty={changeItemProperty}
        />
      </Col>
    </Row>
  );
}

export default PMsContainer;
